import {
	ContainsDropOversContext,
	ContainsDropOversContextData
} from "client/Contexts/ContainsDropOversContext";
import { RegisterElement, useContainsElementStack } from "client/Hooks";
import {
	PropsWithChildren,
	ReactElement,
	useMemo
} from "react";

export type ContainsDropOversWrapperProps = {
	onDoesContainDropOversChange(value: boolean): void;
};

export const ContainsDropOversWrapper = (
	props: PropsWithChildren<ContainsDropOversWrapperProps>
): ReactElement => {
	const {
		onDoesContainDropOversChange,
		children
	} = props;

	const registerDropOver: RegisterElement = useContainsElementStack(
		onDoesContainDropOversChange
	);

	const contextData = useMemo(
		(): ContainsDropOversContextData => {
			return { registerDropOver };
		},
		[registerDropOver]
	);

	return (
		<ContainsDropOversContext.Provider value={contextData}>
			{children}
		</ContainsDropOversContext.Provider>
	);
};
ContainsDropOversWrapper.displayName = "ContainsDropOversWrapper";